__turbopack_context__.v({
  "helios-media": "kQBN9W_helios-media",
  "helios-media--fit-contain": "kQBN9W_helios-media--fit-contain",
  "helios-media--focal-subject-right": "kQBN9W_helios-media--focal-subject-right",
  "helios-media--radius-hero": "kQBN9W_helios-media--radius-hero",
  "helios-media--radius-medium": "kQBN9W_helios-media--radius-medium",
  "helios-media--radius-none": "kQBN9W_helios-media--radius-none",
  "helios-media--ratio-hero": "kQBN9W_helios-media--ratio-hero",
  "helios-media--ratio-landscape": "kQBN9W_helios-media--ratio-landscape",
  "helios-media--ratio-portrait": "kQBN9W_helios-media--ratio-portrait",
  "helios-media--ratio-square": "kQBN9W_helios-media--ratio-square",
  "helios-media--trigger": "kQBN9W_helios-media--trigger",
  "helios-media__image": "kQBN9W_helios-media__image",
  "helios-media__modal-trigger": "kQBN9W_helios-media__modal-trigger",
  "helios-media__picture": "kQBN9W_helios-media__picture",
  "helios-media__video": "kQBN9W_helios-media__video",
});
